import { tv } from '@/common/theme/tv.config';

export const styles = {
  root: tv({
    base: 'relative mb-lg flex grow flex-row items-start justify-start gap-xl border-b border-neutral20',
  }),
  tab: tv({
    base: 'relative cursor-pointer self-start py-2 pb-[12] text-left font-bold',
    variants: {
      active: {
        true: 'text-accentPrimary10',
        false: 'text-neutral40 hover:text-accentPrimary20',
      },
    },
  }),
  badge: tv({
    base: 'align-center ml-xs min-w-[24] content-center justify-center rounded-sm bg-systemWarning20 p-xs px-sm text-xs',
  }),
  activeBorder: tv({
    base: 'absolute bottom-0 left-0 h-[3] w-[24] rounded-t-sm bg-accentSecondary40',
  }),
};
